const userDetailsColumns = [
	{ field: 'userId', header: 'User ID' },
	{ field: 'userName', header: 'User Name' },
	{ field: 'userRole', header: 'User Role' },
	{ field: 'createdBy', header: 'Created By' },
	{ field: 'updatedBy', header: 'Updated By' },
	{ field: 'approvedBy', header: 'Approved By' },
];

export default userDetailsColumns;
